import React from 'react';

import {
	innerWrapperStyle,
	wrapperStyle,
	titleStyle,
	textStyle,
  resourceWrapper,
} from 'inside-out/page-styles/medicare';

import {
	contentSection,
} from 'inside-out/global-styles';

import EDEQImg from 'inside-out/images/medicare/edeq.png';
import TSDImg from 'inside-out/images/medicare/tsd.png';

import { ResourceCard } from 'inside-out/components/shared/cards/resourceCard';

const MedicareForMeStep1Page = () => (
  <div className={wrapperStyle}>
    <section className={contentSection()}>
      <div className={innerWrapperStyle}>
        <h1 className={titleStyle}>Visit your GP</h1>
        <div className={textStyle}>
          You must first be diagnosed with an eating disorder by a GP, paediatrician or psychiatrist. They will develop an Eating Disorder Treatment Plan for you. They will also refer you to a provider of psychological treatment. You can also receive a referral to a dietitian.
        </div>
      </div>
    </section>

    <section className={contentSection('#FFF')}>
      <div className={innerWrapperStyle}>
        <h1 className={titleStyle}>You can complete the Eating Disorders Examination - Questionnaire (EDE-Q) below, and take the results in when you meet your GP</h1>
        <div style={{display: 'flex', marginTop: '24px'}}>
          <div className={resourceWrapper} style={{marginRight: '24px' }}>
            <ResourceCard
              key={0}
              background={ null }
              to={ '/resource-library/eating-disorder-examination-questionnaire-ede-q' }
              audiences={ [] }
              title={ 'EDE-Q' }
              body={ 'This is a self-report version of the Eating Disorder Examination tool which assesses eating disorder pathology.' }
              date={ '1 Nov, 2019' }
            />
          </div>
          <a href="/assessment?started=true">
            <img src={ EDEQImg } style={{display: 'block', margin: '0 auto'}} alt="The EDE-Q assessment" />
          </a>
        </div>
      </div>
    </section>

    <section className={contentSection('#FFF')}>
      <div className={innerWrapperStyle} style={{display: 'flex' }}>
        <div className={textStyle} style={{ marginRight: '24px' }}>
          <h1 className={titleStyle}>Finding a qualified practitioner</h1>
          <p>Your GP may refer you to specific allied health professionals for mental health and dietetic services. However you can also search for clinicians in your area on our Treatment Services database.</p>

          <p>The Butterfly Foundation also have a phone line referral option 1800 33 4673</p>

          <p>ANZAED also has a search for practitioner function <a href="https://www.xcdsystem.com/ANZAED/member_directory/">here</a>.</p>
        </div>
        <a href="/treatment-services">
          <img src={ TSDImg } alt="The treatment services database" />
        </a>
      </div>
    </section>
  </div>
);

export { MedicareForMeStep1Page }



// WEBPACK FOOTER //
// ./src/components/medicare/for-me/step-1.js